import React, { forwardRef } from 'react'
import styled, { css } from 'styled-components'
import Input from './Input'

import { ReactComponent as SearchIcon } from '../../assets/icons/search-icon.svg'
import { Container as InputContainer } from '../../components/Form/Input'
import { Spinner } from 'react-bootstrap'

export const Container = styled.div`
  position: relative;
  width: 100%;

  ${InputContainer}{
    margin-bottom: 0px;
  }
`
const Button = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  width: 56px;
  height: 56px;
  background: transparent;
  border: none;
  height: ${({ height }) => height || '56px'};
  &:focus {
    outline: none;
  }
  svg {
    max-width: 20px;
    max-height: 20px;
    margin: 0px;
    z-index: 1;
  }
  ${({ colorIcon }) => colorIcon && css`
    svg path {
      fill: ${colorIcon}
    }
  `}
`
const SpinnerStyled = styled(Spinner)`
  position: absolute;
  top: 20px !important;
  right: 20px;
  left: initial;
  width: 18px;
  height: 18px;
  color: #00a3b4;
  border-width: .20em;
  z-index: 99;
`

const SearchInput = ({ loading, colorIcon, onClickButton, ...rest }, ref) => {
  const { height } = rest
  return (
    <Container>
      <Input
        ref={ref}
        marginBottom='0px'
        {...rest}
      />
      {loading
        ? <SpinnerStyled animation='border' />
        : <Button onClick={onClickButton} height={height} colorIcon={colorIcon}><SearchIcon /></Button>}
    </Container>
  )
}

export default forwardRef(SearchInput)
